// import React, { useEffect, useState } from 'react';
// import {
//   Building2, Users, Bed, Calendar, DollarSign, TrendingUp,
//   Activity, AlertCircle, CheckCircle, Clock, Settings,
//   BarChart3, PieChart, MessageSquare, Bot, Bell, Menu,
//   Home, Package, UserCog, FileText, Briefcase, Shield
// } from 'lucide-react';
// import axios from 'axios';
// import { useAuth } from '../contexts/AuthContext';
// import { useNavigate } from 'react-router-dom';
// import './ManagerDashboard.css';
// import HotelTab from "./ManagerHotelDetailsTab/ManagerHotelConfigHotelTab";
// import FacilitiesTab from './ManagerFacilitiesTab/FacilitiesTab';
// import RoomTypesTab from './ManagerRoomTypesTab/RoomTypesTab';
// import RoomTypeFacilitiesTab from './ManagerRoomTypesTab/RoomTypeFacilitiesTab';
// import RoomsTab from './ManagerRoomsTab/RoomsTab';

// const API = process.env.REACT_APP_API_URL || 'http://localhost:3001/api/manager/website';

// const TABS = [
//   { key: 'hotel', label: 'Hotel' },
//   { key: 'facilities', label: 'Facilities' },
//   { key: 'roomCategories', label: 'Room Categories' },
//   { key: 'roomTypeFacilities', label: 'Room Type Facilities' },
//   { key: 'rooms', label: 'Rooms' }
// ];

// export default function ManagerHotelConfig() {
//   const { token, userProfile, logout } = useAuth();
//   const navigate = useNavigate();

//   const [activeTab, setActiveTab] = useState('hotel');
//   const [hotel, setHotel] = useState(null);
//   const [facilities, setFacilities] = useState([]);
//   const [roomTypes, setRoomTypes] = useState([]);
//   const [roomTypeFacilities, setRoomTypeFacilities] = useState([]);
//   const [rooms, setRooms] = useState([]);
//   const [floors, setFloors] = useState([]);

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');

//   const hotelRegistered = !!hotel;

//   /* ===================== AUTH & HOTEL LOAD ===================== */
//   useEffect(() => {
//     console.log('[ManagerHotelConfig] token:', token);
//     console.log('[ManagerHotelConfig] userProfile:', userProfile);
//     if (!token || userProfile?.role !== 'manager') {
//       console.log('[ManagerHotelConfig] Redirecting to / because token missing or role !== manager');
//       navigate('/');
//       return;
//     }

//     fetchHotel();
//     // eslint-disable-next-line
//   }, []);

//   const fetchHotel = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(`${API}/hotel`, {
//         headers: { Authorization: `Bearer ${token}` }
//       });
//       setHotel(res.data.data || null);
//     } catch {
//       setHotel(null);
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ===================== TAB DATA LOAD ===================== */
//   useEffect(() => {
//     if (!hotelRegistered) return;

//     const loadTabData = async () => {
//       setLoading(true);
//       setError('');
//       try {
//         if (activeTab === 'facilities') {
//           const res = await axios.get(`${API}/facilities`, auth());
//           setFacilities(res.data.data);
//         }
//         if (activeTab === 'roomCategories') {
//           const res = await axios.get(`${API}/room-types`, auth());
//           setRoomTypes(res.data.data);
//         }
//         if (activeTab === 'roomTypeFacilities') {
//           const res = await axios.get(`${API}/room-type-facilities`, auth());
//           setRoomTypeFacilities(res.data.data);
//         }
//         if (activeTab === 'rooms') {
//           const [r, f] = await Promise.all([
//             axios.get(`${API}/rooms`, auth()),
//             axios.get(`${API}/floors`, auth())
//           ]);
//           setRooms(r.data.data);
//           setFloors(f.data.data);
//         }
//       } catch {
//         setError('Failed to load data');
//       } finally {
//         setLoading(false);
//       }
//     };

//     loadTabData();
//   }, [activeTab, hotelRegistered]);

//   const auth = () => ({
//     headers: { Authorization: `Bearer ${token}` }
//   });

//   /* ===================== TAB RENDER ===================== */
//   const renderTab = () => {
//     switch (activeTab) {
//       case 'hotel':
//         return <HotelTab token={token} />;

//       case 'facilities':
//         return <FacilitiesTab facilities={facilities} setFacilities={setFacilities} />;
    
//       case 'roomCategories':
//         return <RoomTypesTab token={token} />;

//       case 'roomTypeFacilities':
//         return <RoomTypeFacilitiesTab token={token} roomTypes={roomTypes} />;

//       case 'rooms':
//         return <RoomsTab token={token} />;

//       default:
//         return null;
//     }
//   };

//   return (
//     <div className="manager-dashboard">
//       {/* Sidebar */}
//       <div className="manager-sidebar">
//         <div className="sidebar-header">
//           <h2>Manager Portal</h2>
//         </div>
//         <nav className="sidebar-nav">
//           <button onClick={() => navigate('/manager')}>
//             <Home size={20} />
//             <span>Overview</span>
//           </button>
//           <button className="active" onClick={() => navigate('/manager/hotel')} style={{ fontWeight: 600 }}>
//             <Settings size={20} />
//             <span>Hotel Configuration</span>
//           </button>
//           <button onClick={() => navigate('/manager/bookings')}>
//             <Calendar size={20} />
//             <span>Bookings</span>
//           </button>
//           <button onClick={() => navigate('/manager/rooms')}>
//             <Bed size={20} />
//             <span>Rooms</span>
//           </button>
//           <button onClick={() => navigate('/manager/staff')}>
//             <UserCog size={20} />
//             <span>Staff</span>
//           </button>
//           <button onClick={() => navigate('/manager/inventory')}>
//             <Package size={20} />
//             <span>Inventory</span>
//           </button>
//           <button onClick={() => navigate('/iot-management')}>
//             <Settings size={20} />
//             <span>IoT Management</span>
//           </button>
//           <button onClick={() => navigate('/manager/analytics')}>
//             <BarChart3 size={20} />
//             <span>Analytics</span>
//           </button>
//           <button onClick={() => navigate('/manager/reports')}>
//             <FileText size={20} />
//             <span>Reports</span>
//           </button>
//           <button onClick={() => navigate('/manager/settings')}>
//             <Settings size={20} />
//             <span>Settings</span>
//           </button>
//           <button
//             style={{ marginTop: '2rem', color: '#f87171', fontWeight: 600 }}
//             onClick={async () => {
//               await logout();
//               navigate('/login', { replace: true });
//             }}
//           >
//             <Shield size={20} />
//             <span>Log out</span>
//           </button>
//         </nav>
//       </div>

//       {/* Main Content */}
//       <div className="manager-main">
//         <div className="manager-header">
//           <h1>Hotel Configuration</h1>
//           <div className="manager-header-actions">
//             <button className="btn-notifications">
//               <Bell size={20} />
//               <span className="notification-badge">3</span>
//             </button>
//             <button className="btn-menu">
//               <Menu size={20} />
//             </button>
//           </div>
//         </div>

//         <div className="manager-content">
//           <div className="tabs">
//             {TABS.map(tab => (
//               <button
//                 key={tab.key}
//                 disabled={!hotelRegistered && tab.key !== 'hotel'}
//                 className={activeTab === tab.key ? 'active' : ''}
//                 onClick={() => setActiveTab(tab.key)}
//               >
//                 {tab.label}
//               </button>
//             ))}
//           </div>

//           {loading && <p>Loading...</p>}
//           {error && <p className="error">{error}</p>}
//           {success && <p className="success">{success}</p>}

//           {renderTab()}
//         </div>
//       </div>
//     </div>
//   );
// }
import React, { useEffect, useState } from 'react';
import {
  Home, Calendar, Bed, UserCog, Package,
  Settings, BarChart3, FileText, Shield,
  Bell, Menu
} from 'lucide-react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import './ManagerDashboard.css';

import HotelTab from './ManagerHotelDetailsTab/ManagerHotelConfigHotelTab';
import FacilitiesTab from './ManagerFacilitiesTab/FacilitiesTab';
import RoomTypesTab from './ManagerRoomTypesTab/RoomTypesTab';
import RoomTypeFacilitiesTab from './ManagerRoomTypesTab/RoomTypeFacilitiesTab';
import RoomsTab from './ManagerRoomsTab/RoomsTab';
import ActivateHotelTab from './ManagerHotelConfigActivateTab/ManagerHotelConfigActivateTab';
import { API_BASE } from '../config/apiBase';

/* ✅ CORRECT API BASE */
const API = `${API_BASE}/manager/website`;

const TABS = [
  { key: 'hotel', label: 'Hotel' },
  { key: 'facilities', label: 'Facilities' },
  { key: 'roomCategories', label: 'Room Categories' },
  { key: 'roomTypeFacilities', label: 'Room Type Facilities' },
  { key: 'rooms', label: 'Rooms' },
  { key: 'activate', label: 'Activate Hotel' }
];

export default function ManagerHotelConfig() {
  const { token, userProfile, logout } = useAuth();
  const navigate = useNavigate();

  /* ===================== STATE ===================== */
  const [activeTab, setActiveTab] = useState('hotel');
  const [hotel, setHotel] = useState(null);
  const [facilities, setFacilities] = useState([]);
  const [roomTypes, setRoomTypes] = useState([]);
  const [floors, setFloors] = useState([]);
  const [rooms, setRooms] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const hotelRegistered = Boolean(hotel);

  /* ===================== AUTH ===================== */
  useEffect(() => {
    if (!token || userProfile?.role !== 'manager') {
      navigate('/');
      return;
    }
    fetchHotel();
    // eslint-disable-next-line
  }, []);

  const auth = () => ({
    headers: { Authorization: `Bearer ${token}` }
  });

  /* ===================== HOTEL LOAD ===================== */
  const fetchHotel = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API}/hotel`, auth());
      setHotel(res.data.data || null);
    } catch {
      setHotel(null);
    } finally {
      setLoading(false);
    }
  };

  /* ===================== TAB DATA LOAD ===================== */
  useEffect(() => {
    if (!hotelRegistered) return;

    const loadTabData = async () => {
      setLoading(true);
      setError('');

      try {
        if (activeTab === 'facilities') {
          const res = await axios.get(`${API}/facilities`, auth());
          setFacilities(res.data.data);
        }
        if (activeTab === 'roomCategories') {
          const res = await axios.get(`${API}/room-types`, auth());
          setRoomTypes(res.data.data);
        }
        if (activeTab === 'activate') {
          // Fetch ALL relevant data live for activation checklist
          const [hotelRes, facilitiesRes, roomTypesRes, floorsRes, roomsRes] = await Promise.all([
            axios.get(`${API}/hotel`, auth()),
            axios.get(`${API}/facilities`, auth()),
            axios.get(`${API}/room-types`, auth()),
            axios.get(`${API}/floors`, auth()),
            axios.get(`${API}/rooms`, auth())
          ]);
          setHotel(hotelRes.data.data || null);
          setFacilities(facilitiesRes.data.data);
          setRoomTypes(roomTypesRes.data.data);
          setFloors(floorsRes.data.data);
          setRooms(roomsRes.data.data);
        }
      } catch (err) {
        console.error(err);
        setError('Failed to load data');
      } finally {
        setLoading(false);
      }
    };

    loadTabData();
  }, [activeTab, hotelRegistered]);

  /* ===================== TAB RENDER ===================== */
  const renderTab = () => {
    switch (activeTab) {
      case 'hotel':
        return <HotelTab token={token} />;
      case 'facilities':
        return <FacilitiesTab facilities={facilities} setFacilities={setFacilities} />;
      case 'roomCategories':
        return <RoomTypesTab token={token} />;
      case 'roomTypeFacilities':
        return <RoomTypeFacilitiesTab token={token} roomTypes={roomTypes} />;
      case 'rooms':
        return <RoomsTab token={token} />;
      case 'activate':
        return (
          <ActivateHotelTab
            hotel={hotel}
            facilities={facilities}
            roomTypes={roomTypes}
            floors={floors}
            rooms={rooms}
            token={token}
            onActivated={() => setHotel({ ...hotel, status: 'active' })}
          />
        );
      default:
        return null;
    }
  };

  /* ===================== UI ===================== */
  return (
    <div className="manager-dashboard">
      {/* Sidebar */}
      <div className="manager-sidebar">
        <div className="sidebar-header">
          <h2>Manager Portal</h2>
        </div>

        <nav className="sidebar-nav">
          <button onClick={() => navigate('/manager')}>
            <Home size={20} />
            <span>Overview</span>
          </button>

          <button className="active">
            <Settings size={20} />
            <span>Hotel Configuration</span>
          </button>

          <button onClick={() => navigate('/manager/bookings')}>
            <Calendar size={20} />
            <span>Bookings</span>
          </button>

          <button onClick={() => navigate('/manager/rooms')}>
            <Bed size={20} />
            <span>Rooms</span>
          </button>

          <button onClick={() => navigate('/manager/staff')}>
            <UserCog size={20} />
            <span>Staff</span>
          </button>

          <button onClick={() => navigate('/manager/inventory')}>
            <Package size={20} />
            <span>Inventory</span>
          </button>

          <button onClick={() => navigate('/manager/analytics')}>
            <BarChart3 size={20} />
            <span>Analytics</span>
          </button>

          <button onClick={() => navigate('/manager/reports')}>
            <FileText size={20} />
            <span>Reports</span>
          </button>

          <button
            className="logout-btn"
            onClick={async () => {
              await logout();
              navigate('/login', { replace: true });
            }}
          >
            <Shield size={20} />
            <span>Log out</span>
          </button>
        </nav>
      </div>

      {/* Main */}
      <div className="manager-main">
        <div className="manager-header">
          <h1>Hotel Configuration</h1>

          <div className="manager-header-actions">
            <button className="btn-notifications">
              <Bell size={20} />
              <span className="notification-badge">3</span>
            </button>
            <button className="btn-menu">
              <Menu size={20} />
            </button>
          </div>
        </div>

        <div className="manager-content">
          <div className="tabs">
            {TABS.map(tab => (
              <button
                key={tab.key}
                disabled={!hotelRegistered && tab.key !== 'hotel'}
                className={activeTab === tab.key ? 'active' : ''}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {loading && <p>Loading...</p>}
          {error && <p className="error">{error}</p>}

          {renderTab()}
        </div>
      </div>
    </div>
  );
}
